/* Hydrate le badge Trustpilot avec la note/volume live via l'endpoint data du
   TrustBox (sans clé, CORS ouvert — cf. LEARNINGS 2026-07-29). Endpoint non
   documenté : en cas d'échec ou de réponse partielle, les valeurs settings
   rendues côté serveur restent affichées (fallback silencieux).
   Activation par carte : présence de data-ax-tp-business (setting du bloc). */
(() => {
  const TEMPLATE_ID = '54197383fd9dceac42a68694';

  const formatCount = (total) => (total >= 1000 ? `${Math.floor(total / 1000)}K` : `${total}`);

  const hydrate = (card) => {
    if (card.dataset.axTpHydrated) return;
    card.dataset.axTpHydrated = 'true';
    const url = `https://widget.trustpilot.com/trustbox-data/${TEMPLATE_ID}?businessUnitId=${encodeURIComponent(card.dataset.axTpBusiness)}&locale=en-GB`;
    fetch(url)
      .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
      .then((data) => {
        const score = Number(data.trustScore);
        const total = Number(data.businessEntity?.numberOfReviews?.total);
        if (!score || !total) return;
        const rating = card.querySelector('.ax-review-badges__rated strong');
        const count = card.querySelector('.ax-review-badges__count strong');
        if (rating) rating.textContent = score.toFixed(1);
        if (count) count.textContent = formatCount(total);
      })
      .catch(() => {});
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-ax-tp-business]').forEach(hydrate);
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
